import { render, staticRenderFns } from "./TravelServiceOrderItemFlightChip.vue?vue&type=template&id=53b59c2e&scoped=true&"
import script from "./TravelServiceOrderItemFlightChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemFlightChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b59c2e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b59c2e')) {
      api.createRecord('53b59c2e', component.options)
    } else {
      api.reload('53b59c2e', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemFlightChip.vue?vue&type=template&id=53b59c2e&scoped=true&", function () {
      api.rerender('53b59c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemFlightChip.vue"
export default component.exports